import React, { useState, useEffect } from 'react';

const submitStyle = {
    margin: '10px 0 0 0',
    padding: '7px 10px',
    border: '1px solid #efffff',
    borderRadius: '30px',
    background: '#202020',
    width: '95%',
    fontSize: '15px',
    color: 'white',
    display: 'block',
    textAlign: 'center'
};

const Timer = ({ setOtpButton }) => {
    const [time, setTime] = useState(300); // 300 seconds = 5 minutes

    useEffect(() => {
        if (time > 0) {
            const timer = setInterval(() => {
                setTime((prevTime) => prevTime - 1);
            }, 1000);

            return () => clearInterval(timer);
        } else {
            setOtpButton(false);
        }
    }, [time, setOtpButton]);

    // Format the time to MM:SS
    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    return (

        <div style={submitStyle} >{formatTime(time)}</div>

    );
};

export default Timer;
